import React, { useState } from 'react';

/**
 * Campo de formulário com floating label, integrado ao react-hook-form.
 * @param {string} [as] - tipo de elemento: 'input' (padrão), 'textarea', ou 'select'
 * @param {string} [className] - classes aplicadas ao <input>/<textarea>/<select>
 * @param {string} [wrapperClassName] - classes aplicadas ao wrapper .form-floating
 * @param {React.ReactNode} [children] - <option>s, quando as="select"
 * @param {object} [rest] - demais props repassadas ao elemento (ex.: defaultValue, disabled)
 * @param {string} [showPasswordLabel] - aria-label do botão de mostrar senha (só quando type="password"); sem ele, cai em 'Mostrar senha'
 * @param {string} [hidePasswordLabel] - aria-label do botão de ocultar senha (só quando type="password"); sem ele, cai em 'Ocultar senha'
 * Quando type="password", renderiza um botão de olho que alterna o input entre password e text.
 * Fonte: input/textarea usam 16px, select usa 12px, é decisão intencional do componente e não herança do código anterior (país/título em register-v3.js).
 */
export function FormField({ as = 'input', name, type = 'text', label, placeholder, register, options, error, className, wrapperClassName, children, showPasswordLabel, hidePasswordLabel, ...rest }) {
	const Tag = as;
	const isTextarea = as === 'textarea';
	const isSelect = as === 'select';
	const isPassword = type === 'password';

	const [showPassword, setShowPassword] = useState(false);
	const resolvedType = isPassword && showPassword ? 'text' : type;
	

	return (
		<div className={`form-floating form-field mb-15px ${wrapperClassName ?? ''}`}>
			<Tag
				name={name}
				id={name}
				{...(!isTextarea && !isSelect ? { type: resolvedType } : {})}
				{...(!isSelect ? { placeholder } : {})}
				className={`${isSelect ? 'form-select' : 'form-control'} fw-lighter ${isSelect ? 'fs-12px' : 'fs-16px'} ${isTextarea ? 'h-100px' : ''} ${isPassword ? 'pe-icon' : ''} ${className ?? ''}`}
				{...rest}
				{...register(name, options)}
			>
				{children}
			</Tag>
			<label htmlFor={name} className={`d-flex ${isTextarea ? '' : 'align-items-center'} fs-14px text-gray-600`}>
				{label}
				{(options || error) && <span className="text-danger">* {error?.message}</span>}
			</label>
			{isPassword && (
				<button
					type="button"
					onClick={() => setShowPassword((prev) => !prev)}
					className="btn btn-link p-0 password-toggle-btn text-gray-500"
					aria-label={showPassword ? (hidePasswordLabel ?? 'Ocultar senha') : (showPasswordLabel ?? 'Mostrar senha')}
				>
					<i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
				</button>
			)}
		</div>
	);
}
